import { render, staticRenderFns } from "./bus_log_details.vue?vue&type=template&id=a2290ca8&scoped=true"
import script from "./bus_log_details.vue?vue&type=script&lang=js"
export * from "./bus_log_details.vue?vue&type=script&lang=js"
import style0 from "./bus_log_details.vue?vue&type=style&index=0&id=a2290ca8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2290ca8",
  null
  
)

export default component.exports